<template>  
  <v-container id="admin">
    <router-view />
  </v-container>
</template>

<script>

export default {
  name: 'Admin',
  components: {
  },
  data: () => ({
  }),
}
</script>
